import { useState, useEffect } from "react";

/**
 * Custom hook that provides debounced state functionality
 * @param {any} initialValue - Initial value for the state
 * @param {number} delay - Delay in milliseconds for debouncing (default: 500ms)
 * @returns {[any, function, any]} - Returns [debouncedValue, setValue, immediateValue]
 */
const useDebounceState = (initialValue, delay = 500) => {
  const [immediateValue, setImmediateValue] = useState(initialValue);
  const [debouncedValue, setDebouncedValue] = useState(initialValue);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(immediateValue);
    }, delay);

    // Cleanup function to clear timeout if value changes before delay
    return () => {
      clearTimeout(handler);
    };
  }, [immediateValue, delay]);

  return [debouncedValue, setImmediateValue, immediateValue];
};

export default useDebounceState;
